module.exports = __webpack_public_path__ + "static/media/zapier-colored.0c78caad.svg";